import manager from 'app/module46/component-manager.js';

manager.register('same-address', (component, elements, attributes, properties) => {
	
	const $component = $(component);

	const $rows = $component.closest('.form__row').nextAll();

	if($component.prop('checked')) {
		$rows.hide();
	}

	$component.change((ev) => {
		$rows[$component.prop('checked') ? 'hide' : 'fadeIn']();
	});
});
